import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { of } from 'rxjs';

import { BadgeModule } from '@openng/optimus-ui/badge';

import { rxResourceFixed, SkeletonComponent } from '@zayan-erp/shared';
import { DsmApsService } from '../../services/dsm-aps.service';

@Component({
  selector: 'dsm-aps-overview',
  templateUrl: './dsm-aps.component.html',
  imports: [CommonModule, BadgeModule, SkeletonComponent]
})
export class DsmApsOverviewComponent {
  dealId = input.required<string>();

  #service = inject(DsmApsService);

  dealResource = rxResourceFixed({
    params: () => ({ dealId: this.dealId() }),
    defaultValue: null,
    stream: ({ params }) => {
      if (!params.dealId) return of(null);
      return this.#service.getDealHeader(params.dealId, false);
    }
  });

  deal = computed(() => this.dealResource.value());
  isLoading = computed(() => this.dealResource.isLoading());
  closingDate = computed(() => {
    const contract = this.deal()?.contract;
    return contract?.actualClosingDate || contract?.targetClosingDate || null;
  });

  get addressLine(): string {
    const a = this.deal()?.lot?.address;
    if (!a) return '—';
    const parts = [a.streetNo, a.street, a.street2, a.suite].filter(Boolean).join(' ');
    const city = [a.cityName, a.provCode, a.postal].filter(Boolean).join(', ');
    return [parts, city].filter(Boolean).join(', ');
  }
}
